import React from 'react';
import { ITableColumn, TableColumnType, TableList } from "../../../components/table";
import { numberFormatter } from "../../../utils/formatters/numberFormatter";
import { OperacionContraparteLimiteFields } from "../../sistema/sistemas/contraparte/types/fields";
import { OperacionContraparteLimiteAprobado } from "../../sistema/sistemas/contraparte/types/dto";
import {IconButton, Stack, Typography} from "@mui/material";
import {rutaPorCodSistema} from "../../sistema/RefactorLayout";
import LaunchIcon from "@mui/icons-material/Launch";
import {SistemaTipo} from "../../../types/enum/enum";
import {useNavigate} from "react-router-dom";

interface LimitesTablaProps {
    limites: OperacionContraparteLimiteAprobado[];
    loading?: boolean;
    error?: boolean;
}



function LimitesContraparteTabla({ limites, loading, error }: LimitesTablaProps) {
    const navigate = useNavigate();

    const columns: ITableColumn[] = [
        { label: 'Nro. de cuenta', value: OperacionContraparteLimiteFields.NroCuenta },
        { label: 'Razón social', value: OperacionContraparteLimiteFields.RazonSocial },
        {
            label: 'Fecha Aprobación', value: OperacionContraparteLimiteFields.FechaAprobacion, type: TableColumnType.Date
        },
        { label: 'Fecha de vencimiento', value: OperacionContraparteLimiteFields.FechaVencimiento, type: TableColumnType.Date },
        {
            label: 'Concertación',
            onRenderCell: (row: OperacionContraparteLimiteAprobado) => (
                <span>{numberFormatter.toStringWithAmount(row[OperacionContraparteLimiteFields.ImporteConcertacion], row[OperacionContraparteLimiteFields.SimboloMoneda])}</span>
            )
        },
        {
            label: 'DVP',
            onRenderCell: (row: OperacionContraparteLimiteAprobado) => (
                <span>{numberFormatter.toStringWithAmount(row[OperacionContraparteLimiteFields.ImporteDPV], row[OperacionContraparteLimiteFields.SimboloMoneda])}</span>
            )
        },
        {
            label: 'FOP',
            onRenderCell: (row: OperacionContraparteLimiteAprobado) => (
                <span>{numberFormatter.toStringWithAmount(row[OperacionContraparteLimiteFields.ImporteFOP], row[OperacionContraparteLimiteFields.SimboloMoneda])}</span>
            )
        },
        {
            label: 'Operación',
            onRenderCell: (row: OperacionContraparteLimiteAprobado) => {
                return (
                    <>
                        <Stack direction={'row'} alignItems={'center'}>
                            <span># {row[OperacionContraparteLimiteFields.MensajeId]}</span>
                            <IconButton
                                onClick={() => navigate(`/operacion/${rutaPorCodSistema[SistemaTipo.Contrapartes]}/${row[OperacionContraparteLimiteFields.MensajeId]}`)}>
                                <LaunchIcon />
                            </IconButton>
                        </Stack>
                    </>
                )
            }
        }
    ];

    return (
        <TableList
            entityList={limites}
            columns={columns}
            isLoading={!!loading}
            error={error}
        />
    );
}

export default LimitesContraparteTabla;
